import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function SalesFunnel() {
  return (
    <ToolShell
      testid="tool-funnel-page"
      eyebrow="Pro Tool" toolKey="funnel"
      title="Sales Funnel Copy"
      subtitle="Landing page + offer copy, calm-authority style. Pulls from your Dive Brain."
      endpoint="/tools/sales-funnel"
      tier="pro"
      transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "product", label: "Product / offer", type: "textarea", rows: 3, required: true, placeholder: "e.g. 6-week 'Confident Underwater Creator' coaching cohort" },
        { key: "price", label: "Price (EUR)", type: "text", placeholder: "e.g. €890" },
        { key: "ideal_buyer", label: "Ideal buyer", type: "text", placeholder: "e.g. Instructors who want to build a personal brand without becoming an influencer" },
        { key: "transformation", label: "The transformation", type: "textarea", rows: 3, placeholder: "From where → to where in 6 weeks" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-concept" label="Funnel Concept">{o.funnel_concept}</OutputBlock>
          {o.landing_page && (
            <div className="dms-card p-6 space-y-4" data-testid="output-landing-page">
              <div className="dms-label">Landing Page</div>
              <h2 className="font-heading font-bold text-2xl text-[#0A2342]">{o.landing_page.hero_headline}</h2>
              <p className="text-[#475569] text-[15.5px] leading-relaxed">{o.landing_page.hero_subheadline}</p>
              <button className="dms-btn-accent">{o.landing_page.primary_cta}</button>
              {o.landing_page.social_proof_block && <div><span className="dms-label">Social Proof</span><div className="mt-1 text-[14.5px]">{o.landing_page.social_proof_block}</div></div>}
              {o.landing_page.problem_section && <div><span className="dms-label">Problem</span><div className="mt-1 whitespace-pre-wrap text-[14.5px] leading-relaxed">{o.landing_page.problem_section}</div></div>}
              {o.landing_page.solution_section && <div><span className="dms-label">Solution</span><div className="mt-1 whitespace-pre-wrap text-[14.5px] leading-relaxed">{o.landing_page.solution_section}</div></div>}
              {o.landing_page.what_you_get && <div><span className="dms-label">What you get</span><ul className="mt-1 list-disc pl-5">{o.landing_page.what_you_get.map((b, i) => <li key={`wyg-${i}-${String(b).slice(0, 24)}`}>{b}</li>)}</ul></div>}
              {o.landing_page.objection_handling && <div><span className="dms-label">Objections</span><div className="mt-2 space-y-2">{o.landing_page.objection_handling.map((p) => <div key={`obj-${p.objection}`}><div className="font-semibold">{p.objection}</div><div className="text-[#475569]">{p.answer}</div></div>)}</div></div>}
              {o.landing_page.guarantee && <div><span className="dms-label">Guarantee</span><div className="mt-1">{o.landing_page.guarantee}</div></div>}
              {o.landing_page.final_cta && <div><span className="dms-label">Final CTA</span><div className="mt-1">{o.landing_page.final_cta}</div></div>}
            </div>
          )}
          {o.offer_stack && (
            <OutputBlock testid="output-offer-stack" label="Offer Stack">
              <table className="w-full text-[14.5px]">
                <thead>
                  <tr className="text-left text-[11px] tracking-[0.2em] uppercase font-bold text-[#64748B]">
                    <th className="py-2">Item</th><th className="py-2">Value</th><th className="py-2">Purpose</th>
                  </tr>
                </thead>
                <tbody>
                  {o.offer_stack.map((row) => (
                    <tr key={`os-${row.item || row.name || row.description}`} className="border-t border-[#E2E8F0]">
                      <td className="py-2.5">{row.item}</td>
                      <td className="py-2.5">{row.value}</td>
                      <td className="py-2.5 text-[#64748B]">{row.purpose}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </OutputBlock>
          )}
          {o.scarcity_or_urgency && <OutputBlock testid="output-urgency" label="Honest Urgency">{o.scarcity_or_urgency}</OutputBlock>}
        </>
      )}
    />
  );
}
